import QRCode from 'qrcode';
import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import IconFont from '@meitu/xdesign-icon-font';

interface IPreviewModelProps {
    closeModel: Function;
    url: string;
}

const PreviewModel: React.FC<IPreviewModelProps> = ({ closeModel, url }) => {
    const [container, setContainer] = useState<HTMLDivElement | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        const newContainer = document.createElement('div');
        document.body.appendChild(newContainer);
        setContainer(newContainer);

        return () => {
            document.body.removeChild(newContainer);
        };
    }, []);

    useEffect(() => {
        if (!canvasRef.current || !url) {
            return;
        }
        QRCode.toCanvas(canvasRef.current, url, {}, function (error: any) {
            if (error) console.error(error);
            if (!canvasRef.current) {
                return;
            }
            canvasRef.current.style.width = '272px';
            canvasRef.current.style.height = '272px';
            console.log('success!');
        });
    }, [canvasRef.current, container]);

    const close = () => {
        closeModel();
    };

    return container
        ? (ReactDOM.createPortal(
              <div
                  style={{
                      position: 'absolute',
                      left: '0',
                      top: '0',
                      width: '100%',
                      height: '100%',
                      zIndex: '1000',
                      display: 'flex',
                      background: 'rgba(0,0,0,0.5)',
                      alignItems: 'center',
                      justifyContent: 'center',
                  }}
              >
                  <div
                      style={{
                          position: 'relative',
                          display: 'flex',
                          width: '350px',
                          height: '400px',
                          padding: '30px 20px',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          boxSizing: 'border-box',
                          flexShrink: '0',
                          borderRadius: '25.524px',
                          background: '#FFF',
                          boxShadow: '0px 4.25402px 23.39712px 0px rgba(0, 0, 0, 0.25)',
                      }}
                  >
                      <div>
                          <div
                              style={{
                                  position: 'absolute',
                                  right: '20px',
                                  top: '20px',
                                  cursor: 'pointer',
                              }}
                              onClick={close}
                          >
                              <IconFont name="CrossBlack" fontSize={14}></IconFont>
                          </div>
                          <div
                              style={{
                                  fontSize: '20px',
                                  width: '100%',
                                  textAlign: 'center',
                              }}
                          >
                              扫一扫查看展示效果
                          </div>
                          <canvas
                              width={272}
                              height={272}
                              style={{
                                  width: '272px',
                                  height: '272px',
                                  border: '1px soild #e5e5e5',
                              }}
                              ref={canvasRef}
                          />
                      </div>
                  </div>
              </div>,
              container,
          ) as any)
        : null;
};

export default PreviewModel;
